import { reactive } from "vue";

// Shared first-load intro signal. The loading overlay owns the opening
// choreography (night background + the iconomy mark drawing on). The hero
// waits for `done` before running its own entrance so the statements rise
// only after the overlay has cleared and the nav has slid in.
//
// pending:  a first full-page load is still being choreographed by the overlay.
// done:     the overlay has handed off — components may run their entrances.
// yHandoff: landing-page first load only — the overlay's drawn y flies into the
//           hero's corner mark, so the hero must NOT reveal its own y (the
//           overlay sets it visible when the flight lands).
export const introState = reactive({
  pending: true,
  done: false,
  yHandoff: false,
});
